import React, { useCallback } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import {
  selectCompanySubsidiaries,
  selectCompanySubsidiariesCount,
  selectCompanySubsidiariesEnded,
  selectCompanySubsidiariesLoading,
  selectCompanySubsidiariesPage,
} from 'Selector/CompaniesSelector';
import { actions as companiesActions } from 'Slice/CompaniesSlice';
import SubsidiariesGrid from './SubsidiariesGrid';
import {
  primaryHeadingColor, wLight, secondaryFont, maxMobile,
} from '../../../Utils/utilsStyle';

const Wrapper = styled.div`
  margin-bottom: 90px;
  h2 {
    color: ${primaryHeadingColor};
    font-size: 28px;
    font-weight: ${wLight};
    font-family: ${secondaryFont};
    margin-bottom: 25px;
    @media all and (max-width: ${maxMobile}) {
      font-size: 20px;
      margin-bottom: 10px;
    }
  }
`;

const CompanySubsidiaries = function CompanySubsidiaries() {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const companyId = parseInt(searchParams.get('companyId') || '0', 10);
  const companies = useSelector(selectCompanySubsidiaries);
  const loading = useSelector(selectCompanySubsidiariesLoading);
  const ended = useSelector(selectCompanySubsidiariesEnded);
  const page = useSelector(selectCompanySubsidiariesPage);
  const count = useSelector(selectCompanySubsidiariesCount);

  const fetchMore = useCallback(() => {
    if (companyId) {
      dispatch(companiesActions.getCompanySubsidiaries({ companyId, page }));
    }
  }, [companyId, page]);

  return (
    <Wrapper>
      <div className="mt-50 heading-text">
        <h2>{count ? `Subsidiaries (${count})` : 'Subsidiaries'}</h2>
      </div>
      <SubsidiariesGrid
        companies={companies}
        loading={loading}
        ended={ended}
        onLoadMore={fetchMore}
      />
    </Wrapper>
  );
};

export default React.memo(CompanySubsidiaries);
